import axios from 'axios';
import qs from 'qs';
import that from '../main';
import { showLoading, hideLoading } from '../common/plugins/loading';

const $http = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_OA,
    timeout: 10000,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});

// 请求qs序列化;
$http.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        showLoading();
        if (
            config.headers['Content-Type'] ===
            'application/x-www-form-urlencoded'
        ) {
            config.data = qs.stringify(config.data, {
                arrayFormat: 'indices',
                allowDots: true
            });
        }
        if (token) {
            config.headers.token = token;
        }
        return config;
    },
    error => {
        that.$message.error(error && error.data.error_msg);
        return Promise.reject(error.data.error_msg);
    }
);

// 接收数据，刷新token，封装res
$http.interceptors.response.use(
    res => {
        let resD = res.data;
        if (resD) {
            switch (resD.code) {
                case 401:
                    that.$message.error('验证失败，请重新登录');
                    localStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: '/login'
                        });
                    }, 1000);
                    hideLoading();
                    break;
                case 400:
                    that.$message.error('错误的请求。');
                    localStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: '/login'
                        });
                    }, 1000);
                    hideLoading();
                    break;
                case 403:
                    that.$message.error('已经经过身份验证的用户不允许访问指定的 API 末端。');
                    localStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: '/login'
                        });
                    }, 1000);
                    hideLoading();
                    break;
                case 200:
                    hideLoading();
                    return resD;
                case 404:
                    that.$message.error(
                        '所请求的资源不存在。'
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: '/login'
                        });
                    }, 1000);
                    hideLoading();
                    break;
                case 405:
                    that.$message.error(
                        '不被允许的方法。 请检查 Allow header 允许的HTTP方法。'
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: '/login'
                        });
                    }, 1000);
                    hideLoading();
                    break;
                case 422:
                    that.$message.error(resD.msg);
                    hideLoading();
                    return false;
                case 415:
                    that.$message.error(
                        '不支持的媒体类型。 所请求的内容类型或版本号是无效的。'
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: '/login'
                        });
                    }, 1000);
                    hideLoading();
                    break;
                case 500:
                    that.$message.error(
                        '内部服务器错误。 这可能是由于内部程序错误引起的。'
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        that.$router.push({
                            path: '/login'
                        });
                    }, 1000);
                    hideLoading();
                    break;
                default:
                    //其他默认返回的blob文件流
                    return res.data;
            }
        }
    },
    error => {
        that.$message.error(
            '请求超时，请检查网络。'
        );
        localStorage.clear();
        setTimeout(() => {
            that.$router.push({
                path: '/login'
            });
        }, 1000);
        hideLoading();
    }
);

export default $http;
